import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  value: number;
  size?: "sm" | "md" | "lg";
  editable?: boolean;
  onChange?: (v: number) => void;
  className?: string;
}

const SIZE = { sm: "h-3.5 w-3.5", md: "h-5 w-5", lg: "h-7 w-7" };

export function StarRating({ value, size = "md", editable = false, onChange, className }: Props) {
  return (
    <div
      className={cn("flex items-center gap-0.5", className)}
      role={editable ? "radiogroup" : undefined}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(value);
        const icon = (
          <Star
            className={cn(
              SIZE[size],
              filled ? "fill-coral text-coral" : "text-muted-foreground/40",
            )}
            aria-hidden
          />
        );
        return editable ? (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={n === Math.round(value)}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            onClick={() => onChange?.(n)}
            className="rounded-sm p-0.5 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {icon}
          </button>
        ) : (
          <span key={n}>{icon}</span>
        );
      })}
    </div>
  );
}
